import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, injectIntl} from 'react-intl';

import {connect} from '@stubhub/react-store-provider';

import {getVFSImageUrl} from '../../../../../../helpers/listing-helper';
import RoyalMap from '../../../react-royal-map';
import RoyalMapController from '../../../react-royal-map/controller';

/**
 * @param section
 * @param row
 * @param seats
 */
class ViewBYOSeat extends PureComponent {
  state = {
    vfsImageError: false,
  };

  getVFSPath = () => {
    const {venueId, venueConfigId, sectionId} = this.props;

    return getVFSImageUrl({venueId, venueConfigId, sectionId});
  };

  onImageLoadFailure = () => {
    this.setState({
      vfsImageError: true,
    });
  };

  renderBYOSeatMap = () => {
    const {listing} = this.props;

    return (
      <div style={{height: '300px', width: '100%'}}>
        <RoyalMap
          handleCloseBYO={() => {
            // Do nothing
          }}
          listingInfo={listing}
        />
      </div>
    );
  };

  renderBYOViewFromSeat = (VFSPath) => {
    const {intl} = this.props;

    return (
      <img
        className="ViewFromSeat"
        src={VFSPath}
        onError={() => {
          this.onImageLoadFailure();
        }}
        alt={intl.formatMessage({
          id: 'BYOB.ViewFromSeat',
          defaultMessage: 'View from seat',
        })}
      />
    );
  };

  componentDidUpdate(prevProps) {
    const {sectionId: prevSectionId} = prevProps;
    const {sectionId} = this.props;
    if (sectionId !== prevSectionId) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        vfsImageError: false,
      });
    }
  }

  render() {
    const VFSPath = this.getVFSPath();
    const {viewFromSection, sectionStats, isGA, showMap} = this.props;
    const {vfsImageError} = this.state;
    const showViewFromSeat = VFSPath && viewFromSection && !vfsImageError;

    return (
      <>
        {!isGA && (
          <div className="ViewSeat">
            {showViewFromSeat && this.renderBYOViewFromSeat(VFSPath)}
            {!showViewFromSeat && showMap && sectionStats && this.renderBYOSeatMap()}
          </div>
        )}
        {!isGA && showViewFromSeat && (
          <div className="view-approximate">
            <FormattedMessage id="BYOB.viewApproximate" defaultMessage="View is approximate" />
          </div>
        )}
      </>
    );
  }
}

ViewBYOSeat.propTypes = {
  /** is General Admission? */
  isGA: PropTypes.bool,

  /** listing object */
  listing: PropTypes.object.isRequired,

  /** Id of the section */
  sectionId: PropTypes.number.isRequired,

  /** Section stats */
  sectionStats: PropTypes.array.isRequired,

  /** Venue configuration id */
  venueConfigId: PropTypes.number.isRequired,

  /** Venue id */
  venueId: PropTypes.number.isRequired,

  /** show view from section? */
  viewFromSection: PropTypes.bool,

  /** React intl object */
  intl: PropTypes.object,

  /** Show byo mini map? */
  showMap: PropTypes.bool,
};

export default connect(RoyalMapController)(injectIntl(ViewBYOSeat));
